<template>
  <div class="bg-neutral-300 shadow p-8 flex flex-col rounded">
    <div class="w-full flex justify-center" v-if="loading">
      <Lynx-Spinner size="12" />
    </div>

    <form
      v-if="empresaAlteracao"
      @submit.prevent="submitForm"
      class="flex flex-col"
    >
      <Lynx-Title
        :text="`Alteração e Baixa de Empresa: #${empresaAlteracao.alteracao.empresa.id}`"
      />

      <div
        class="bg-neutral-100 border border-neutral-400 rounded p-6 mb-6 flex-wrap flex"
      >
        <span
          class="text-lg font-display border-b border-neutral-400 w-full pb-2 flex mb-4"
        >
          Solicitação
        </span>

        <p v-if="!editar">
          {{ empresaAlteracao.solicitacao.observacao }}
        </p>

        <b-input class="w-5/6" v-if="editar" v-model="observacao" />
        <button
          v-if="!editar"
          class="flex items-center justify-center ml-3"
          @click.prevent="editar = true"
        >
          <b-icon icon="circle-edit-outline"></b-icon>
        </button>
        <button
          v-if="editar"
          class="flex items-center justify-center ml-3"
          @click.prevent="editar = false"
        >
          <b-icon icon="check"></b-icon>
        </button>
      </div>

      <!-- SÓCIOS-->
      <div class="mb-8">
        <span
          class="text-lg font-display border-b border-neutral-400 w-full pb-2 flex mb-4"
        >
          Sócios
        </span>

        <ul v-if="form.socios.length" class="py-2 mb-2">
          <li
            v-for="(socio, index) in form.socios"
            :key="index"
            class="flex justify-between items-center py-2"
          >
            <div class="w-full flex items-center">
              <span> {{ socio.nome_completo }} | CPF: {{ socio.cpf }} </span>

              <button
                v-if="form.socio_administrador != socio.id"
                class="pl-1 flex items-center justify-center flex-shrink-0 text-neutral-500"
                @click.prevent="form.socios.splice(index, 1)"
              >
                <b-icon icon="delete-forever"></b-icon>
              </button>
            </div>

            <b-radio
              v-model="form.socio_administrador"
              :native-value="socio.id"
              class="flex-shrink-0 ml-4"
            >
              Administrador
            </b-radio>
          </li>
        </ul>

        <div
          class="w-full h-full flex flex-col justify-center items-center"
          v-else
        >
          <NotFoundData text="Nenhum sócio adicionado" />
        </div>

        <Lynx-Button
          text="Adicionar Sócio"
          @click.prevent.native="addSocio"
          icon="Plus"
        />
      </div>

      <!-- DADOS EMPRESA -->
      <div class="mb-8 flex flex-wrap">
        <span
          class="text-lg font-display border-b border-neutral-400 w-full pb-2 flex mb-4"
        >
          Dados da Empresa
        </span>

        <label class="block w-full">
          <Lynx-Label label="Nome Fantasia" />

          <Lynx-Input
            placeholder="Insira o Nome Fantasia"
            v-model="form.empresa.nome_fantasia"
          />
        </label>

        <label class="block w-full">
          <Lynx-Label label="Razão Social" />

          <Lynx-Input
            placeholder="Insira o Razão Social"
            v-model="form.empresa.razao_social"
          />
        </label>

        <label class="block w-1/3 pr-4">
          <Lynx-Label label="Regime Tributário" />

          <b-select
            placeholder="Escolha um Regime Tributário"
            v-model="form.empresa.regime_tributario"
          >
            <option value="SN">Simples Nacional</option>
            <option value="Presumido">Presumido</option>
            <option value="Isento">Isento</option>
            <option value="Eand">Aguardando enquadramento no simples</option>
            <option value="Presumido_equi">presumido com equiparação</option>
            <option value="MEI">Microempreendedor Individual (MEI)</option>
          </b-select>
        </label>

        <label class="block w-1/3 pr-4">
          <Lynx-Label label="Tipo Societário" />

          <b-select
            placeholder="Escolha um Tipo Societário"
            v-model="form.empresa.tipo_societario"
          >
            <option value="LTDA">LTDA</option>
            <option value="Eireli">Eireli</option>
            <option value="Individual">Individual</option>
            <option value="Unipessoal">Unipessoal</option>
            <option value="ONG">ONG</option>
          </b-select>
        </label>

        <b-checkbox
          class="block flex-shrink-0 pt-2"
          v-model="form.empresa.clinica_fisica"
          >Possui Clinica Física</b-checkbox
        >
      </div>

      <!-- CONTATOS -->
      <div class="mb-8 flex flex-wrap">
        <span
          class="w-full text-lg font-display border-b border-neutral-400 pb-2 flex mb-4"
        >
          Contatos da Empresa
        </span>

        <div class="w-1/2 pr-4">
          <span class="font-display w-full pb-2 flex items-center">
            Emails

            <b-button
              size="is-small"
              type="is-primary"
              @click.prevent="addEmail"
              class="ml-2"
            >
              Adicionar
            </b-button>
          </span>

          <div
            class="flex items-center w-full pb-6"
            v-for="(email, index) in contatosEmail"
            :key="index"
          >
            <button
              v-if="index != 0"
              class="pr-1 flex items-center justify-center flex-shrink-0 text-neutral-500"
              @click.prevent="contatosEmail.splice(index, 1)"
            >
              <b-icon icon="delete-forever"></b-icon>
            </button>

            <Lynx-Input
              placeholder="Insira um email"
              type="email"
              v-model="email.value"
              class="w-full"
            />

            <b-checkbox class="flex-shrink-0 ml-2" v-model="email.optin">
              Notificação
            </b-checkbox>
          </div>
        </div>

        <div class="w-1/2 pl-4">
          <span class="font-display w-full pb-2 flex items-center">
            Celulares

            <b-button
              size="is-small"
              type="is-primary"
              @click.prevent="addCelular"
              class="ml-2"
            >
              Adicionar
            </b-button>
          </span>

          <div
            class="flex items-center w-full pb-6"
            v-for="(celular, index) in contatosCelular"
            :key="index"
          >
            <button
              v-if="index != 0"
              class="pr-1 flex items-center justify-center flex-shrink-0 text-neutral-500"
              @click.prevent="contatosCelular.splice(index, 1)"
            >
              <b-icon icon="delete-forever"></b-icon>
            </button>

            <Lynx-Input
              placeholder="Insira um celular"
              v-model="celular.value"
              mask="(##) #####-####"
              class="w-full"
            />

            <b-checkbox class="flex-shrink-0 ml-2" v-model="celular.optin">
              Notificação
            </b-checkbox>
          </div>
        </div>
      </div>

      <!-- ENDEREÇO -->
      <div class="mb-8">
        <span
          class="text-lg font-display border-b border-neutral-400 w-full pb-2 flex mb-4"
        >
          Endereço da Empresa
        </span>

        <div class="flex">
          <label class="flex flex-col w-1/3 pr-4 pb-6">
            <Lynx-Label label="CEP" />

            <Lynx-Input
              placeholder="Insira o CEP"
              v-model.trim="form.endereco.cep"
              mask="#####-###"
              @input="fetchCep"
            />
          </label>

          <label class="flex flex-col w-1/3 pr-4 pb-6">
            <Lynx-Label label="IPTU" />

            <Lynx-Input
              placeholder="Insira o IPTU"
              v-model.trim="form.endereco.iptu"
              mask="####################"
            />
          </label>
        </div>

        <div class="w-full flex">
          <label class="flex flex-col w-1/2 pb-6 pr-2">
            <Lynx-Label label="Logradouro" />

            <Lynx-Input
              placeholder="Insira o Logradouro"
              v-model.trim="form.endereco.logradouro"
            />
          </label>

          <label class="flex flex-col w-1/4 px-2 pb-6">
            <Lynx-Label label="Numero" />

            <Lynx-Input
              placeholder="Insira o Número"
              v-model.trim="form.endereco.numero"
            />
          </label>

          <label class="flex flex-col w-1/4 pl-2 pb-6">
            <Lynx-Label label="Complemento" />
            <Lynx-Input
              placeholder="Insira o Número"
              v-model="form.endereco.complemento"
            />
          </label>
        </div>

        <p style="font-size: 12px">
          Obs: Caso preencher CEP primeiro, os campos serão automaticamente preenchidos
        </p>
        <div class="w-full flex">
          <label class="flex flex-col w-1/5 pb-6 pr-2">
            <Lynx-Label label="Estado" />
            <Treeselect
              :options="lista_estados"
              placeholder="Selecione o estado"
              v-model="form.endereco.estado_id"
            />
          </label>

          <label class="flex flex-col w-2/5 px-2 pb-6">
            <Lynx-Label label="Cidade" />

            <Treeselect
              :options="lista_cidades"
              placeholder="Selecione a cidae"
              v-model="form.endereco.cidade_id"
            />
          </label>

          <label class="flex flex-col w-2/5 px-2 pb-6">
            <Lynx-Label label="Bairro" />

            <Lynx-Input
              placeholder="Insira o bairro"
              v-model.trim="form.endereco.bairro"
            />
          </label>
        </div>
      </div>

      <div class="flex justify-between">
        <Lynx-Button
          @click.native.prevent="alterar('Finalizar')"
          type="button"
          text="Finalizar Alteração"
          class="self-start"
          color="success-base"
          :loading="loading"
          :disable="loading"
        />
        <Lynx-Button
          v-if="visibleEtapa(empresaAlteracao)"
          @click.native.prevent="alterar('Proxima')"
          type="button"
          text="Próxima etapa"
          class="self-start"
          color="info-base"
          :loading="loading"
          :disable="loading"
        />

        <Lynx-Button
          style="color: white"
          type="submit"
          text="Salvar"
          class="self-end"
          :loading="loading"
          :disable="loading"
        />
      </div>
    </form>

    <b-modal :active.sync="clienteSearchModalOpened">
      <ClienteSearchModal @selected="onClienteSelected" />
    </b-modal>
  </div>
</template>

<script>
import {
  EmpresaAlteracaoUpdate,
  FinalizarEmpresaAlteracao,
  EmpresaAlteracaoProximaEtapa,
} from "@/services/requests/empresaAlteracao";
import { viaCepRequest } from "@/services/requests/viaCep";
import ClienteSearchModal from "@/views/clientes/SearchModal";
import {
  indexEstadosRequest,
  showEstadosRequest,
} from "@/services/requests/estados";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
export default {
  name: "EmpresasAlteracaoEditModal",
  components: { ClienteSearchModal, Treeselect },
  props: ["empresaAlteracao"],
  data() {
    return {
      clienteSearchModalOpened: false,
      contatosEmail: [{ tipo: "email", value: "", optin: true }],
      contatosCelular: [
        {
          tipo: "celular",
          value: "",
          optin: true,
          options: { is_whatsapp: true },
        },
      ],
      form: {
        socio_administrador: null,
        socios: this.empresaAlteracao.alteracao.socios,

        empresa: {
          ...this.empresaAlteracao.alteracao.empresa,
          razao_social:
            this.empresaAlteracao.alteracao.empresa.nome_empresa ||
            this.empresaAlteracao.alteracao.empresa.razao_social,
        },

        contatos: this.empresaAlteracao.alteracao.contatos,

        endereco: this.empresaAlteracao.alteracao.endereco,
      },
      loading: false,
      editar: false,
      observacao: this.empresaAlteracao.solicitacao.observacao,
      estados: [],
      cidades: [],
    };
  },
  computed: {
    lista_cidades() {
      return this.generateSelectOptions(this.cidades);
    },
    lista_estados() {
      return this.generateSelectOptions(this.estados);
    },
  },
  mounted() {
    this.fetchEstados();
    this.fetchSocioAdmministrador();
    this.fetchContatos();
  },
  watch: {
    "form.endereco.estado_id": function () {
       if(this.form.endereco.estado_id){
      this.onSelectEstado(this.form.endereco.estado_id);
      }else{
        this.cidades = [];
        this.form.endereco.cidade_id = null
      }
    },
  },
  methods: {
    addSocio() {
      this.clienteSearchModalOpened = true;
    },
    onClienteSelected(cliente) {
      this.clienteSearchModalOpened = false;

      const clientesIds = this.form.socios.map((socio) => socio.id);

      if (clientesIds.includes(cliente.id)) {
        this.$snack.warning("O cliente já foi adicionado como sócio!");
        return;
      }

      this.form.socios.push({ ...cliente });

      if (this.form.socios.length == 1) {
        this.form.socio_administrador = cliente.id;
      }
    },
    fetchContatos() {
      const emails = this.form.contatos.filter(
        (contato) => contato.tipo == "email"
      );
      const celulares = this.form.contatos.filter(
        (contato) => contato.tipo == "celular"
      );

      if (emails.length) {
        this.contatosEmail = emails;
      }

      if (celulares.length) {
        this.contatosCelular = celulares;
      }
    },
    addEmail() {
      this.contatosEmail.push({ tipo: "email", value: "", optin: true });
    },
    addCelular() {
      this.contatosCelular.push({
        tipo: "celular",
        value: "",
        optin: true,
        options: { is_whatsapp: true },
      });
    },
    fetchSocioAdmministrador() {
      if (this.empresaAlteracao.alteracao.socio_administrador) {
        this.form.socio_administrador =
          this.empresaAlteracao.alteracao.socio_administrador;
        return;
      }

      const socio_administrador = this.empresaAlteracao.alteracao.socios.filter(
        (socio) => (socio.pivot ? socio.pivot.socio_administrador : "")
      );
      this.form.socio_administrador = socio_administrador.length
        ? socio_administrador[0].id
        : null;
    },
    fetchCep(cep) {
      if (cep.length != 8) return;
      viaCepRequest(cep).then((res) => {
        if (res.data.erro) return;
        this.form.endereco.logradouro = res.data.logradouro;
        this.form.endereco.cidade = res.data.localidade;
        this.form.endereco.bairro = res.data.bairro;
        this.form.endereco.ibge = res.data.ibge;
        this.form.endereco.uf = res.data.uf;
        this.form.endereco.estado_id = this.estados.find(
          (estado) => estado.uf === this.form.endereco.uf
        ).id;
      });
    },
    submitForm() {
      this.loading = true;
      this.form.observacao = this.observacao;
      const data = {
        alteracao: {
          ...this.form,
          contatos: [...this.contatosEmail, ...this.contatosCelular],
        },
      };

      EmpresaAlteracaoUpdate(this.empresaAlteracao.id, data)
        .then(() => {
          this.$snack.success("Alteração salva com sucesso!");
          this.$emit("edited");
        })
        .catch((error) => {
          const errors = Object.values(error.response.data.errors);
          const message = errors
            .map((item) => item.map((error) => `<li>${error}</li>`).join(""))
            .join("");

          this.$buefy.dialog.alert({
            title: "Não foi possível solicitar a alteração",
            message: `<ul>${message}</ul>`,
            type: "is-danger",
            ariaRole: "alertdialog",
            ariaModal: true,
          });
        })
        .finally(() => (this.loading = false));
    },
    alterar(tipo) {
      const msg =
        tipo == "Finalizar"
          ? "finalizar o processo dessa empresa?"
          : "passar de etapa";
      this.$buefy.dialog.confirm({
        title: tipo == "Finalizar" ? "Finalizar Alteração" : "Proxíma etapa",
        message: "Tem certeza que deseja " + msg + "?",
        confirmText: tipo == "Finalizar" ? "Finalizar" : "Passar etapa",
        type: "is-success",
        hasIcon: true,
        onConfirm: () => {
          this.loading = true;
          if (tipo == "Finalizar") {
            this.finalizarAlteracao();
          } else {
            this.proximaEtapa();
          }
        },
      });
    },
    finalizarAlteracao() {
      FinalizarEmpresaAlteracao(this.empresaAlteracao.id)
        .then(() => {
          this.$snack.success("Processo finalizado com sucesso!");
          this.$emit("edited");
        })
        .catch((error) => {
          const errors = Object.values(error.response.data.errors);
          const message = errors
            .map((item) => item.map((error) => `<li>${error}</li>`).join(""))
            .join("");
          this.$buefy.dialog.alert({
            title: "Não foi possível solicitar a alteração",
            message: `<ul>${message}</ul>`,
            type: "is-danger",
            ariaRole: "alertdialog",
            ariaModal: true,
          });
        })
        .finally(() => (this.loading = false));
    },
    proximaEtapa() {
      EmpresaAlteracaoProximaEtapa(this.empresaAlteracao.id)
        .then(() => {
          this.$snack.success("Alteração salva com sucesso!");
          this.$emit("edited");
        })
        .finally(() => (this.loading = false));
    },
    visibleEtapa(empresaAlteracao) {
      switch (empresaAlteracao.solicitacao.tipo) {
        case "Baixa da empresa":
          return empresaAlteracao.status_id == 2;
          break;

        case "Endereço":
          return false;
          break;

        case "Transformação de Empresa":
        case "Atividade/CNAE/Outros":
        case "Sócio/Administrador":
          if (empresaAlteracao.status_id == 2) {
            return false;
          }
          return true;
          break;

        default:
          return false;
      }
    },
    fetchEstados() {
      this.loading = true;
      indexEstadosRequest()
        .then((res) => (this.estados = res.data))
        .finally(() => (this.loading = false));
      if (this.form.endereco.estado_id) {
        this.onSelectEstado(this.form.endereco.estado_id);
      }
    },
    async onSelectEstado(id) {
      this.loading = true;
      await showEstadosRequest(id)
        .then((res) => (this.cidades = res.data.cidades))
        .finally(() => (this.loading = false));

      this.form.endereco.cidade_id = this.cidades.find(
        (item) => item.nome == this.form.endereco.cidade
      ).id;
    },
    generateSelectOptions(data) {
      let options = [];
      for (let i = 0; i < data.length; i++) {
        options.push({ id: data[i].id, label: data[i].nome });
      }
      return options;
    },
  },
};
</script>
